<script>
  import chroma from 'chroma-js'

  let formatNumber = new Intl.NumberFormat()
  import activeGauteng from '../data/active-gautengshutdown.json'
  import { scaleLinear, scaleTime, scaleLog } from 'd3-scale'
  import { extent, max } from 'd3-array'
  import avatars from '../data/avatars.json'
  import MobileActiveUsers from '../components/MobileActiveUsers.svelte'

  function getAvatar(username) {
    let a = avatars.find((x) => x.username === username)
    if (a) {
      return a.twitter_profile_pic
    } else {
      return ''
    }
  }
  let tweets = activeGauteng.filter((document, i) => i < 20)
  tweets.forEach((d) => {
    d.avatar = getAvatar(d.username)
  })

  let width = 300

  $: r1Scale = scaleLinear()
    .domain([0, max(tweets, (d) => d.tweets)])
    .range([10, 45])

  $: r2Scale = scaleLinear()
    .domain([0, max(tweets, (d) => d.retweets)])
    .range([10, 45])

  let maxTweets = max(tweets, (d) => d.tweets)
  let maxRetweets = max(tweets, (d) => d.retweets)

  let colorScale = chroma.scale(['hotpink', 'ffd3e9']).domain([maxTweets, 0])
  let colorScaleRetweets = chroma
    .scale(['hotpink', 'ffd3e9'])
    .domain([maxRetweets, 0])

  //   $: xScale = scaleTime()
  //     .domain(extent(tweets, (d) => d.retweets))
  //     .range([margin.left, width - margin.right])

  //   $: yScale = scaleLinear()
  //     .domain([0, max(tweets, (d) => +d.tweets)])
  //     .range([height - margin.bottom, margin.top])

  //   $: xTicks = xScale.ticks(24)
  //   $: yTicks = yScale.ticks(5)

  let margins = {
    left: 30,
    right: 30,
  }
</script>

<MobileActiveUsers {tweets} />
<div class="active-users-desktop">
  <table>
    <tr> <td /><td bind:clientWidth={width} colspan="2" /></tr>

    {#each tweets as tweet, index}
      <tr class="table-tweet-row">
        <td class="username">
          <a href="https://twitter.com/@{tweet.username}" target="_blank"
            >@{tweet.username}</a
          >
          <div
            class="avatar"
            style="background-image: url({tweet.avatar});"
          /></td
        >
        <td colspan="2">
          <svg {width} height="40">
            <line
              x1={margins.left}
              x2={width - margins.right}
              y1="25"
              y2="25"
              stroke="gray"
              stroke-width="2"
              class="link"
            />
            <circle
              cx={margins.left}
              cy="25"
              r={r1Scale(tweet.tweets) / 2}
              style="fill: {colorScale(tweet.tweets)}"
            />
            <circle
              cx={width - margins.right}
              cy="25"
              r={r2Scale(tweet.retweets) / 2}
              style="fill: {colorScaleRetweets(tweet.retweets)}"
            />
            {#if index === 0}
              <text x={margins.left * 2} y="28" class="labels"
                >{tweet.tweets} tweets</text
              >{:else}
              <text x={margins.left * 2} y="28" class="labels"
                >{tweet.tweets}</text
              >
            {/if}
            {#if index === 0}
              <text
                x={width - margins.right * 2}
                y="28"
                class="labels labels-right"
                >{formatNumber.format(tweet.retweets)} retweets</text
              >
            {:else}
              <text
                x={width - margins.right * 2}
                y="28"
                class="labels labels-right"
                >{formatNumber.format(tweet.retweets)}</text
              >
            {/if}
          </svg>
        </td>
        <!-- <td class="tweet-count">
          <div
            class="tweets-count"
            style="width: {r1Scale(tweet.tweets)}px; height: {r1Scale(
              tweet.tweets
            )}px;"
          >
            {tweet.tweets}
          </div>
          <div class="tweets-spacer"><div class="spacer" /></div>
          <div
            class="retweets-count"
            style="width: {r2Scale(tweet.retweets)}px; height: {r2Scale(
              tweet.retweets
            )}px;"
          >
            {tweet.retweets}
          </div>
        </td> -->
      </tr>
    {/each}
  </table>
</div>

<style>
  .avatar {
    background: url(/images/twitter-default.png) no-repeat center center;
    display: inline-block;
    width: 30px;
    height: 30px;
    border-radius: 50%;
    border: solid 2px #505050;
    transform: translate(0, 10px);
    margin-left: 10px;
  }
  table {
    width: 100%;
  }
  .active-users {
    text-align: center;
    /* border: solid 1px red; */
    max-width: 600px;
    margin-left: auto;
    margin-right: auto;
    /* background: rgb(65, 65, 65); */
  }
  svg {
    overflow: visible;
  }
  .username {
    font-family: var(--titleFont);
    font-weight: 700;
    font-size: 0.9rem;
    text-align: right;
    padding-right: 10px;
  }

  .tweet-count {
    display: grid;
    grid-template-columns: 1fr 3fr 1fr;
  }
  .tweets-count {
    width: 40px;
    height: 40px;
    border-radius: 50%;
    background: hotpink;
    text-align: center;
    /* padding-top: 10px; */
    font-size: 0.7rem;
    display: flex;
    align-items: center;
    justify-content: center;
    color: #000;
  }
  .retweets-count {
    width: 40px;
    height: 40px;
    border-radius: 50%;
    background: hotpink;
    text-align: center;
    /* padding-top: 10px; */
    font-size: 0.7rem;
    display: flex;
    align-items: center;
    justify-content: center;
    color: #000;
  }
  .spacer {
    width: 90%;
    border-top: dotted 2px rgb(121, 121, 121);
    transform: translate(0, 20px);
    margin-left: 5%;
    margin-right: 5%;
  }

  .link {
    stroke-dasharray: 4, 4;
    stroke-width: 1px;
    shape-rendering: crispEdges;
  }
  .labels {
    fill: rgb(161, 161, 161);
    font-size: 0.8rem;
    font-weight: 700;
    text-anchor: start;
    text-transform: uppercase;
    paint-order: stroke;
    stroke-width: 5px;
    stroke: #000;
  }
  .labels-right {
    text-anchor: end;
  }
  td {
    /* border: solid 1px gray; */
    max-width: 300px;
  }
  circle {
    stroke: #fff;
    stroke-width: 2px;
  }

  @media only screen and (max-width: 800px) {
  }
</style>
